import Checkins from './checkins';

export default Checkins;
